import useGustoCompanyId from 'components/domain/integration/gusto/hooks/company/useGustoCompanyId/useGustoCompanyId';

export default function useGustoIsAuthenticated() {
  return useGustoCompanyId() !== null;
}
